export default __webpack_public_path__ + "static/media/plus_gray.b5340e90.svg";